<template>
  <div v-if="this.izbranPrikljucek !== ''">
    <div class="odmik-top-40">
      <div v-if="(trenutniTrzniPaket !== null || seznamVezav.length > 0)">
        <div>
          <div>
            <ul>
              <li>
                <img src="/static/img/MojT2/Pregled%20storitev/T2-logo.png"
                     style="padding-bottom: 10px; padding-right: 5px">
                <span class="open-sans-20pt">
                  Podatki o priključku
                </span>
              </li>
            </ul>
          </div>
          <div style="padding-top: 20px" v-if="this.trenutniTrzniPaket !== null && this.trenutniTrzniPaket !== ''">
            <p class="navadno-besedilo">
              Naročen paket:
              <span>
                <a class="navadno-besedilo" href="/Naroci/NarociT2Paket" style="cursor: pointer">
                  <b>
                    {{ trenutniTrzniPaket.naziv }}
                  </b>
                </a>
              </span>
            </p>
          </div>
          <div v-if="this.trenutniTrzniPaketVklopljenOd !== null">
            <p class="navadno-besedilo">
              Datum vklopa:
              <span>
                <a class="navadno-besedilo" href="/Naroci/NarociT2Paket" style="cursor: pointer">
                  <b>
                    {{ trenutniTrzniPaketVklopljenOd }}
                  </b>
                </a>
              </span>
            </p>
          </div>
          <div v-if="prikazTabele === '1'" style="padding-top: 30px">
            <div v-if="seznamVezav !== '' && seznamVezav.length > 0 ">
              <el-table
                :data="seznamPodVezav"
                style="width: 100%">
                <el-table-column
                  prop="naziv"
                  label="Storitev vezave"/>
                <el-table-column
                  width="100px"
                  align="center"
                  prop="popustProcenti"
                  label="Popust v %"/>
                <el-table-column
                  align="center"
                  width="200px"
                  prop="trajanjeUgodnosti"
                  label="Trajanje ugodnosti"/>
                <el-table-column
                  align="center"
                  width="150px"
                  prop="trajanjeOd"
                  label="Začetek vezave"/>
                <el-table-column
                  align="center"
                  width="150px"
                  prop="trajanjeDo"
                  label="Konec vezave"/>
              </el-table>
            </div>
          </div>
          <div v-else>
            <el-table
              :data="seznamPodVezav"
              style="width: 100%">
              <el-table-column>
                <template slot-scope="props">
                  <p>
                    <span>
                      <b>
                        Storitev:
                      </b>
                    </span>
                    {{ props.row.naziv }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Začetek vezave:
                      </b>
                    </span>
                    {{ props.row.trajanjeOd }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Konec vezave:
                      </b>
                    </span>
                    {{ props.row.trajanjeDo }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <br/>
          <div class="text-center">
            <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStranSeznamVezav"
              :page-size="4"
              layout="prev, pager, next"
              :total="dolzinaSeznamaVezav"
              small>
            </el-pagination>
          </div>
          <div class="postavitev-povezave odmik-zgoraj manjsi-odmik-2">
            <a
              href="/Naroci/NarociT2Paket"
              class="el-button okvir-povezave tekst-povezave gumb-potrdi"
              style="cursor: pointer;"
              v-if="hasPrikljuckeTrzniPaketi"
            >
              T-2 PAKETI
            </a>
            <a :href="cenikiT2Storitev" class="el-button okvir-povezave tekst-povezave" style="cursor: pointer;">
              CENIKI T-2 STORITEV
            </a>
          </div>
          <div>
            <span class="opozorilo">
              <el-icon class="el-icon-info" style="padding-top:3px">
              </el-icon>
              <span class="opozorilo-mobile">
                Vsakokrat veljavni ceniki so objavljeni na T-2 spletni strani in na T-2 prodajnih mestih.
              </span>
            </span>
          </div>
        </div>
        <br>
        <hr class="hr-stil"/>
        <br>
      </div>
    </div>
    <div v-if="fiksniPrikljucek">
      <div style="padding-top: 30px">
        <div>
          <ul>
            <li>
              <img src="/static/img/MojT2/Pregled%20storitev/Icon-awesome-plug.png"
                   style="padding-bottom: 10px; padding-right: 5px">
              <span class="open-sans-20pt">
                Širokopasovne internetne storitve
              </span>
            </li>
          </ul>
          <div class="navadno-besedilo" style="padding-top: 34px">
            <el-form label-width="170px" :label-position="formaOrientacija">
              <el-form-item label="Internetna hitrost:" v-if="trenutnoIzbranaHitrost !== null">
                <b>
                  {{ trenutnoIzbranaHitrost.naziv }}
                </b>
              </el-form-item>
              <el-form-item label="Varnostni paket:" v-if="varnostniPaket !== null">
                <b>
                  {{ varnostniPaket.naziv }}
                </b>
              </el-form-item>
              <div v-if="prikazpodatkovInternet = 0 && trenutnaPostavitevInternetVec.length > 0">
                <div v-for="internetIp in trenutnaPostavitevInternetVec">
                  <br>
                  <el-form-item label="Statični IP naslov:">
                    <b>
                      {{ internetIp.ip }}
                    </b>
                  </el-form-item>
                  <el-form-item label="Maska omrežja:">
                    <b>
                      {{ internetIp.maska }}
                    </b>
                  </el-form-item>
                  <el-form-item label="Privzeti prehod:">
                    <b>
                      {{ internetIp.prehod }}
                    </b>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
          <div v-if="podatkiWifi !== null && Object.keys(podatkiWifi).length !== 0">
            <div style="padding-top: 30px; float: left" class="navadno-besedilo">
              <el-form label-width="170px" :label-position="formaOrientacija">
                <el-form-item label="Ime wifi omrežja (SSID):">
                  <b>
                    {{ podatkiWifi.SSID }}
                  </b>
                </el-form-item>
                <el-form-item label="Geslo wifi omrežja:">
                  <b>
                    {{ podatkiWifi.PSK }}
                  </b>
                </el-form-item>
              </el-form>
            </div>
            <div>
            </div>
            <div style="float: right">
              <InfoKomponentaNaroceneStoritve/>
            </div>
            <div style="clear: both"/>
          </div>
          <div class="navadno-besedilo odmik-stevila-emailov" v-if="naroceniPostniPredali !== null">
            <el-form label-width="170px" :label-position="formaOrientacija">
              <el-form-item label="Število predalov elektronske pošte:">
                <b>
                  {{ naroceniPostniPredali.steviloNarocenih }}
                </b>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="prikazpodatkovInternet = 1 && trenutnaPostavitevInternetVec.length > 0"
               style="padding-top: 30px; padding-bottom: 30px">
            <el-table
              :data="trenutnaPostavitevInternetVec">
              <el-table-column
                prop="ip"
                label="Statični IP naslov">
              </el-table-column>
              <el-table-column
                prop="maska"
                label="Maska omrežja">
              </el-table-column>
              <el-table-column
                prop="prehod"
                label="Privzeti prehod">
              </el-table-column>
            </el-table>
          </div>
          <div class="postavitev-povezave odmik-zgoraj manjsi-odmik">
            <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer"
               @click="PregledHistoriPopUp">
              PREVERITE HITROST
            </a>
          </div>
          <div>
            <span class="opozorilo">
              <el-icon class="el-icon-info" style="padding-top:5px">
              </el-icon>
              <span class="opozorilo-mobile">
                Informacije o storitvah dostopa do interneta ter morebitnih omejitvah skladno s Splošnim aktom o storitvah
                dostopa do interneta in s tem povezanih pravic končnih uporabnikov so objavljene
                <a href="https://www.t-2.net/informacije-o-storitvah-dostopa-do-interneta" class="primarna-barva">
                  tukaj</a>.
              </span>
            </span>
          </div>
          <div v-if="podatkiWifi !== null && Object.keys(podatkiWifi).length === 0 &&
            typeof podatkiWifi.SSID === 'undefined'">
            <InfoKomponentaNaroceneStoritve/>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      append-to-body
      :fullscreen="fullscreenDialogHitrost"
      class="uspesno-obvestilo preverjanje-hitrosti"
      :visible.sync="dialogPregledHitrosti"
      center>
      <div style="padding-top: 10px">
        <div style="padding-bottom: 10px">
          <div v-if="trenutniPrenosDownload !== 0 && trenutniPrenosUpload !== 0">
            <div style="text-align: center">
              <img src="/static/img/MojT2/Pregled%20storitev/Icon-feather-arrow-down-circle.png">
              <b class="stil-download-uploud">
                Download:
              </b>
              {{this.trenutniPrenosDownload}}
            </div>
            <div class="postavitev-slike-hitrosti">
              <img src="/static/img/MojT2/Pregled%20storitev/Icon%20feather-arrow-down-circle.png">
              <b class="stil-download-uploud">
                Upload:
              </b>
              {{this.trenutniPrenosUpload}}
            </div>
          </div>
          <div v-else>
            <p class="navadno-besedilo brez-hitrosti">
              Trenutno žal nimamo podatkov o hitrosti! Preverite povezavo ali nas pokličite na
              <a class="primarna-barva">064 064 064</a>.
            </p>
          </div>
          <div class="postavitev-slike-hitrosti">
            <img src="/static/img/MojT2/Pregled%20storitev/time_management_1_.png">
          </div>
        </div>
        <p class="navadno-besedilo vsebina-hitrosti-text">
          Podrobnejše informacije o hitrosti prenosa podatkov na vašem priključku, o vplivih na kakovost
          storitev dostopa do interneta je dostopnih na spletni strani
          <a class="primarna-barva" :href="splosniPogojiURL" target="_blank">
            splosni pogoji podjetja
          </a>
          v dokumentu "Opredelitev internetnih hitrosti in mobilnega prenosa podatkov".
        </p>
      </div>
      <el-button class="gumb-brez-obrob krepko crna" @click="dialogPregledHitrosti = false">
        Zapri
      </el-button>
    </el-dialog>
    <div v-if="seznamOpreme !== undefined && seznamOpreme.length > 0" v-loading="pridobivanjeSeznamaOpreme">
      <br>
      <hr class="hr-stil"/>
      <br>
      <div style="padding-top: 30px">
        <ul>
          <li>
            <img src="/static/img/MojT2/Pregled%20storitev/Icon-material-devices-other.png"
                 style="padding-bottom: 10px; padding-right: 5px">
            <span class="open-sans-20pt">
              Seznam opreme
            </span>
          </li>
        </ul>
        <div v-if="prikazTabele === '1'">
          <el-table
            :data="seznamPodMrezneOpreme">
            <el-table-column
              prop="naziv"
              label="Naziv opreme">
            </el-table-column>
            <el-table-column
              prop="serijskaStevilka"
              label="Serijska številka">
            </el-table-column>
            <el-table-column
              prop="stanje"
              label="Status">
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table
            :data="seznamPodMrezneOpreme">
            <el-table-column>
              <template slot-scope="props">
                <p>
                  <span>
                    <b>
                     Naziv opreme:
                    </b>
                  </span>
                  <a class="primarna-barva">
                    {{ props.row.naziv }}
                  </a>
                </p>
                <p>
                  <span>
                    <b>
                      Serijska številka:
                    </b>
                  </span>
                  {{ props.row.serijskaStevilka }}
                </p>
                <p>
                  <span>
                    <b>
                     Status:
                    </b>
                  </span>
                  {{ props.row.stanje }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <br>
        <div class="text-center">
          <el-pagination
            :hide-on-single-page="true"
            @current-change="PrikaziStranSeznamOpreme"
            :current-page="trenutnoIzbranaStran"
            :page-size="4"
            layout="prev, pager, next"
            :total="dolzinaSeznamaMrezneOpreme"
            small>
          </el-pagination>
        </div>
      </div>
      <div class="postavitev-povezave odmik-zgoraj-35 manjsi-odmik">
        <el-button class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer">
          <download-excel
            :data="seznamOpreme"
            :fields="jsonFieldsSeznamOpreme"
            worksheet="Izvoz seznama opreme"
            name="Izvoz_seznama_opreme.xls">
            IZVOZI SEZNAM OPREME
          </download-excel>
        </el-button>
      </div>
    </div>
    <div v-if="seznamProgramov !== '' && seznamProgramov !== null && seznamTvShem !== null && typeof
            seznamTvShem !== 'undefined' && seznamTvShem.length > 0">
      <br>
      <span  v-if="!ottPrepaidPrikljucek && !ottPrikljucek">
        <hr class="hr-stil"/>
        <br>
      </span>
      <div :style="!ottPrikljucek ? 'padding-top: 30px' : ''">
        <div>
          <ul>
            <li>
              <img src="/static/img/MojT2/Pregled%20storitev/Icon-feather-tv.png"
                   style="padding-bottom: 10px; padding-right: 5px">
              <span class="open-sans-20pt">
                Televizija
              </span>
            </li>
          </ul>
          <div>
            <span v-if="sdVmesnikKolicina.length > 0 && sdVmesnikKolicina !== null">
              <p>
                Število TV vmesnik:
                <span>
                  {{ sdVmesnikKolicina.kolicina }}
                </span>
              </p>
            </span>
            <span v-if="hdVmesnikKolicina.length > 0 && hdVmesnikKolicina !== null">
              <p>
                Število HDTV vmesnik:
                <span style="color:#EF7D00;">
                  {{ hdVmesnikKolicina.kolicina }}
                </span>
              </p>
            </span>
            <span v-if="seznamTvShem !== null && seznamTvShem !== '' && seznamTvShem.length > 0">
              <p class="navadno-besedilo">
                Programska shema:
                <span v-for="(tvShema, key) in seznamTvShem" :key="key">
                  <b>
                    {{ tvShema.naziv }}
                  </b>
                </span>
              </p>
            </span>
            <span v-if="seznamProgramov.length > 0 && seznamProgramov !== null">
              <p class="navadno-besedilo">
                Dodatni TV paketi:
                <span v-for="(program, key) in seznamProgramov" :key="key">
                  <b>
                    {{ program.naziv + ',' }}
                  </b>
                </span>
              </p>
            </span>
            <div>
              <div class="container" style="padding-top: 20px">
                <div v-if="sdVmesnikKolicina > 0">
                  <p class="navadno-besedilo">
                    Število SD TV vmesnikov:
                    <b class="primarna-barva">
                      {{ sdVmesnikKolicina }}
                    </b>
                  </p>
                </div>
                <div v-if="hdVmesnikKolicina > 0">
                  <p class="navadno-besedilo">
                    Število HD TV vmesnikov:
                    <b class="primarna-barva">
                      {{ hdVmesnikKolicina }}
                    </b>
                  </p>
                </div>
                <div v-if="coaxVmesnikKolicina > 0">
                  <p class="navadno-besedilo">
                    Najem TV kartice - coax:
                    <b class="primarna-barva">
                      {{ coaxVmesnikKolicina }}
                    </b>
                  </p>
                </div>
                <div v-if="seznamSmartTv > 0">
                  <p class="navadno-besedilo">
                    Število smart TV:
                    <b class="primarna-barva">
                      {{ seznamSmartTv }}
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="naroceneStrotive.length > 0" style="padding-top: 10px; padding-bottom: 10px">
            <el-table
              :data="naroceneStrotive">
              <el-table-column
                prop="naziv"
                label="Naročena storitev">
              </el-table-column>
              <el-table-column
                prop="trajanjeOd"
                label="Datum zakupa">
              </el-table-column>
              <el-table-column
                prop="trajanjeDo"
                label="Datum poteka">
                <template slot-scope="scope">
                  <div v-if="scope.row.trajanjeDo === '01.01.2300 00:00'">
                    do preklica
                  </div>
                  <div v-else>
                    {{ scope.row.trajanjeDo }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="postavitev-povezave manjsi-odmik">
            <a class="el-button okvir-povezave tekst-povezave el-button--default gumb-potrdi" style="cursor: pointer;"
               href="/Naroci/NarociTelevizija">
              NASTAVITVE
            </a>
            <a :href="ottToSubscription" style="padding-left: 20px;" v-if="ottPrepaidPrikljucek">
              <el-button class="gumb-potrdi upravljaj-narocnino">
                UPRAVLJAJ Z NAROČNINO
              </el-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="seznamUmtsStevilk.length > 0 && seznamUmtsStevilk !== null &&
      seznamPodUmtsStevilk.filter(x => x.id_prikljucek == izbranPrikljucek).length > 0">
      <br>
      <br>
      <div>
        <div>
          <ul>
            <li>
              <img src="/static/img/MojT2/Pregled%20storitev/Icon-material-smartphone.png"
                   style="padding-bottom: 10px; padding-right: 5px">
              <span class="open-sans-20pt">
                Mobilna telefonija
              </span>
            </li>
          </ul>
          <div v-if="prikazTabele === '1'">
            <el-table
              :data="seznamPodUmtsStevilk.filter(x => x.id_prikljucek === izbranPrikljucek)">
              <el-table-column
                prop="umts_stevilka"
                label="Telefonska številka">
              </el-table-column>
              <el-table-column
                prop="ObjavlenoVimeniku"
                label="Objava v imeniku">
              </el-table-column>
              <el-table-column label="Naročen paket">
                <template slot-scope="scope">
                  <span v-if="scope.row.trzni_paket !== ''">
                    {{ scope.row.trzni_paket}}
                  </span>
                  <span v-if="scope.row.trzni_paket === '' && podatkovniPaketi !== null">
                    {{podatkovniPaketi.naziv}}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <el-table
              :data="seznamPodUmtsStevilk"
              stripe
            >
              <el-table-column>
                <template slot-scope="props">
                  <p>
                    <span>
                      <b>
                       Telefonska številka:
                      </b>
                    </span>
                    <a class="primarna-barva">
                      {{ props.row.umts_stevilka }}
                    </a>
                  </p>
                  <p>
                    <span>
                      <b>
                        Objava v imeniku:
                      </b>
                    </span>
                    {{ props.row.ObjavlenoVimeniku }}
                  </p>
                  <p>
                    <span>
                      <b>
                       Naročen paket:
                      </b>
                    </span>
                    <span v-if="props.row.trzni_paket !== ''">
                      {{ props.row.trzni_paket}}
                    </span>
                    <span v-if="props.row.trzni_paket === '' && podatkovniPaketi !== null">
                      {{podatkovniPaketi.naziv}}
                    </span>
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="postavitev-gumbov postavitev-povezave manjsi-odmik">
            <div>
              <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer"
                 href="/Poraba/PorabaTelefonija">
                PREGLED PORABE
              </a>
            </div>
            <div>
              <a class="" href="/Nastavitve/NastavitveTelefonija">
                <el-button class="gumb-potrdi">
                  NASTAVITVE
                </el-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="seznamFiksnihStevilk.length > 0 && seznamFiksnihStevilk !== null">
      <br>
      <hr class="hr-stil"/>
      <br>
      <div style="padding-top: 30px">
        <div>
          <ul>
            <li>
              <img src="/static/img/MojT2/Pregled%20storitev/Icon-awesome-phone-alt.png"
                   style="padding-bottom: 10px; padding-right: 5px">
              <span class="open-sans-20pt">
                Fiksna telefonija
              </span>
            </li>
          </ul>
          <div v-if="prikazTabele === '1'">
            <el-table
              :data="seznamFiksnihStevilk">
              <el-table-column
                prop="telefonska_stevilka"
                label="Telefonska številka">
              </el-table-column>
              <el-table-column
                prop="ObjavlenoVimeniku"
                label="Objava v imeniku">
              </el-table-column>
              <el-table-column
                prop="trzni_paket"
                label="Naročen paket">
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <el-table
              :data="seznamPodFiksnihStevilk">
              <el-table-column>
                <template slot-scope="props">
                  <p>
                    <span>
                      <b>
                       Telefonska številka:
                      </b>
                    </span>
                    <a class="primarna-barva">
                      {{ props.row.telefonska_stevilka }}
                    </a>
                  </p>
                  <p>
                    <span>
                      <b>
                        Objava v imeniku:
                      </b>
                    </span>
                    {{ props.row.ObjavlenoVimeniku }}
                  </p>
                  <p>
                    <span>
                      <b>
                       Naročen paket:
                      </b>
                    </span>
                    {{ props.row.trzni_paket }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="text-center">
            <br>
            <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStranFiksnaTelefonija"
              :current-page="trenutnoIzbranaStraFiks"
              :page-size="4"
              layout="prev, pager, next"
              :total="dolzinaSeznamaFiks"
              small>
            </el-pagination>
          </div>

          <div class="postavitev-gumbov postavitev-povezave manjsi-odmik">
            <div>
              <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer"
                 href="/Poraba/PorabaTelefonija">
                PREGLED PORABE
              </a>
            </div>
            <div>
              <a href="/Nastavitve/NastavitveTelefonija">
                <el-button class="gumb-potrdi">
                  NASTAVITVE
                </el-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fiksniPrikljucek &&  seznamVklopljenih.length > 0" style="padding-top: 20px">
      <hr class="hr-stil"/>
      <ul class="odmik-top-40">
        <li>
          <img src="/static/img/MojT2/Pregled storitev/T2-logo.png"
               style="padding-bottom: 10px; padding-right: 5px">
          <span class="open-sans-20pt">
                Vklopljene storitve
              </span>
        </li>
      </ul>
      <div v-if="seznamVklopljenih !== undefined && seznamVklopljenih !== '' && seznamVklopljenih.length > 0 ">
        <el-table
            :data="seznamPodStoritev"
            style="width: 100%">
          <el-table-column
              prop="naziv"
              label="Storitev">
          </el-table-column>
          <el-table-column
              prop="narocenoNaVmesniku"
              label="Mesto aktivacije">
          </el-table-column>
          <el-table-column
              prop="trajanjeOd"
              label="Začetek storitve">
          </el-table-column>
          <el-table-column
            label="Konec storitve">
            <template slot-scope="scope">
              <span v-if="scope.row.trajanjeDo === '01.01.2300 00:00'">
                Do preklica
              </span>
              <span v-else>
                {{ scope.row.trajanjeDo }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="vPaketu"
            label="Znotraj paketa">
          <template slot-scope="scope">
            <span>
              {{scope.row.vPaketu !== null ? `Da - ${scope.row.vPaketu}` : 'Ne'}}
            </span>
          </template>
          </el-table-column>
        </el-table>
        <br/>
        <div class="text-center">
          <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStranSeznamStoritev"
              :page-size="6"
              layout="prev, pager, next"
              :total="dolzinaSeznamaStoritev"
              small>
          </el-pagination>
        </div>
        <span class="opozorilo">
          <el-icon class="el-icon-info" style="padding-top:3px">
          </el-icon>
          <span class="opozorilo-mobile">
            V seznamu boste našli vse vklopljene storitve.
            Stolpec »Mesto aktivacije« označuje spletno stran ali drugo aplikacijo, kjer je bila storitev naročena.
            Naziv ostalo pomeni, da je bilo izvedeno naročilo
            v poslovalnici, s klicem v kontaktni center, preko T-2 Kluba ali na drug način.
          </span>
        </span>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="obvestilo-prazen-seznam">
      <p>
        Nimate naročenih storitev.
      </p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import {StoritevVrstaEnum} from '../../../../../assets/js/Enum/StoritevVrstaEnum.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {Select, Option, CollapseItem, Collapse, Alert, TableColumn, Button, Pagination, Dialog} from 'element-ui'
import JsonExcel from 'vue-json-excel'
import InfoKomponentaNaroceneStoritve from '../../MojT2/Pregledstoritev/InfoKomponentaNaroceneStoritve'
import {SeznamVrednosti} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SeznamVrednosti'

Vue.component('downloadExcel', JsonExcel)
export default {
  name: 'NaroceneStoritve',
  mixins: [SeznamVrednosti, PrikazVsebine, PridobivanjeVklopljenoNaroceno, StoritevVrstaEnum, PretvorbaEnot, SirinaOkna],
  data () {
    return {
      clientAgent: null,
      trenutnoIzbranaHitrost: null,
      trenutnaPostavitevInternetEna: [],
      trenutnaPostavitevInternetVec: [],
      trenutniPrenosDownload: null,
      trenutniPrenosUpload: null,
      trenutniTrzniPaket: null,
      trenutniTrzniPaketVklopljenOd: null,
      naroceniPostniPredali: null,
      varnostniPaket: null,
      seznamTrOprema: '',
      seznamVezav: [],
      seznamProgramov: [],
      seznamTelefonskih: '',
      hdVmesnikKolicina: 0,
      sdVmesnikKolicina: 0,
      coaxVmesnikKolicina: 0,
      seznamTvShem: [],
      formaOrientacija: 'left',
      mejnaSirina: 350,
      podatkiWifi: null,
      seznamPodRacunov: [],
      seznamMobilnihStevilk: [],
      seznamOpreme: [],
      seznamFiksnihStevilk: [],
      seznamVezavVklopljenih: [],
      seznamSmartTv: [],
      seznamPodVezav: [],
      dolzinaSeznamaVezav: 0,
      dolzinaSeznamaStoritev: 0,
      dolzinaSeznamaUmts: 0,
      prikljuckiTrzniPaketi: [],
      seznamUmts: [],
      trenutnoIzbranaStran: 1,
      trenutnoIzbranaStraUmts: 1,
      trenutnoIzbranaStraFiks: 1,
      prikazpodatkovInternet: 0,
      seznamUmtsStevilk: [],
      seznamPodUmtsStevilk: [],
      seznamPodMrezneOpreme: [],
      pridobivanjeSeznamaOpreme: false,
      naroceneStrotive: [],
      dialogPregledHitrosti: false,
      seznamPodFiksnihStevilk: [],
      seznamVklopljenih: [],
      seznameStoritveInternet: this.GetVrsteStoritveInternet(),
      jsonFieldsSeznamOpreme: {
        'Naziv opreme': 'naziv',
        'Serijska številka': 'serijskaStevilka',
        'Status': 'stanje'
      },
      json_meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      splosniPogojiURL: null,
      fullscreenDialogHitrost: false,
      fiksniPrikljucek: false,
      cenikiT2Storitev: povezave.BASE_URL_CENIKI_T_2_STORITEV,
      ottToSubscription: povezave.BASE_URL_OTT_TV_T2_SUBSCRIPTION,
      seznamVklopljenihStoritev: [],
      seznamPodStoritev: [],
      datumVklopa: null,
      ottPrikljucek: false,
      ottPrepaidPrikljucek: false,
      seznamIskanihStoritev: [
        StoritevVrstaEnum.TELEVIZIJA,
        StoritevVrstaEnum.VARNOST,
        StoritevVrstaEnum.TV_PAKETI,
        StoritevVrstaEnum.TRZNI_PAKET,
        StoritevVrstaEnum.NAROCNISKA_VEZAVA,
        StoritevVrstaEnum.PODATKOVNI_PAKETI,
        StoritevVrstaEnum.T2_SCIT
      ],
      seznamIskanihStoritevUMTS: [
        StoritevVrstaEnum.TRZNI_PAKET,
        StoritevVrstaEnum.PODATKOVNI_PAKETI
      ],
      prenosniParametriZaStoritve: {},
      prenosniParametriZaStoritveUMTS: {},
      podatkovniPaketi: null
    }
  },
  props: {
    seznamPrikljuckov: [],
    izbranPrikljucek: null,
    izbranSap: null
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.prenosniParametriZaStoritve = {
          'vmesnik': this,
          'prenesenIzbranId': this.izbranPrikljucek,
          'idVrsta': [].concat(this.seznamIskanihStoritev, this.seznameStoritveInternet),
          'idStatusNaroceno': 0,
          'idStatusVklopljeno': 1
        }
        this.PridobitevTrenutniNarocnik()
        let prikljucekObj = this.seznamPrikljuckov.find(x => x.id_prikljucek === this.izbranPrikljucek)
        if (typeof prikljucekObj !== 'undefined') {
          this.ottPrikljucek = prikljucekObj.tip_prikljucka === 'OTT'
          this.fiksniPrikljucek = prikljucekObj.tip_prikljucka === 'FIX'
          this.ottPrepaidPrikljucek = prikljucekObj.tip_prikljucka === 'PREPAID'
          if (this.fiksniPrikljucek || this.ottPrikljucek) {
            this.PridobitevStaticnegaApija()
            this.PridobitevTrenutniPrenos()
            this.PridobitevNarocenihPostnihPredalov()
            this.GetSeznamOpreme()
            this.GetVklopljeneStoritve(this.prenosniParametriZaStoritve)
            this.GetNaroceneStoritve(this.prenosniParametriZaStoritve)
          } else {
            this.GetPrikljuckiUTMS()
          }
        }
        this.PridobimoTvShemo()
        this.GetSmartTvInfo()
        this.seznamOpreme = []
        this.seznamFiksnihStevilk = []
        this.trenutniTrzniPaket = null
      }
    },
    orientacija: function (val) {
      this.formaOrientacija = val
    }
  },
  components: {
    InfoKomponentaNaroceneStoritve,
    PretvorbaEnot,
    StoritevVrstaEnum,
    PridobivanjeVklopljenoNaroceno,
    [Option.name]: Option,
    [Select.name]: Select,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Alert.name]: Alert,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [Dialog.name]: Dialog
  },
  mounted () {
    this.splosniPogojiURL = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.GetPrikljuckiTrzniPaketi()
    if (this.izbranPrikljucek !== null) {
      let prikljucekObj = this.seznamPrikljuckov.find(x => x.id_prikljucek === this.izbranPrikljucek)
      if (typeof prikljucekObj !== 'undefined') {
        this.fiksniPrikljucek = prikljucekObj.tip_prikljucka === 'FIX'
        if (this.fiksniPrikljucek) {
          this.PridobitevTrenutniPrenos()
          this.PridobitevNarocenihPostnihPredalov()
          this.PridobitevTrenutniNarocnik()
          this.PridobitevStaticnegaApija()
          this.GetSeznamOpreme()
          this.prenosniParametriZaStoritve = {
            'vmesnik': this,
            'prenesenIzbranId': this.izbranPrikljucek,
            'idVrsta': [].concat(this.seznamIskanihStoritev, this.seznameStoritveInternet),
            'idStatusNaroceno': 0,
            'idStatusVklopljeno': 1
          }
        }
        this.GetPrikljuckiUTMS()
        this.PridobimoTvShemo()
        this.GetSmartTvInfo()
        this.seznamOpreme = []
        this.seznamFiksnihStevilk = []
        this.trenutniTrzniPaket = null
        this.GetVklopljeneStoritve(this.prenosniParametriZaStoritve)
        this.GetNaroceneStoritve(this.prenosniParametriZaStoritve)
      }
    }
  },
  methods: {
    SirinaOknaPresegaVrednost (param) {
      if (param.currentTarget.innerWidth < 600) {
        this.fullscreenDialogHitrost = true
      }
    },
    PregledHistoriPopUp () {
      this.dialogPregledHitrosti = true
    },
    SetSeznamVkloplenihStoritev (prenosniParametri, pridobljenSeznamVklopljenih) {
      this.seznamProgramov = []
      this.seznamVezav = []
      this.podatkovniPaketi = null
      this.trenutniTrzniPaket = null
      if (typeof pridobljenSeznamVklopljenih !== 'undefined' && pridobljenSeznamVklopljenih.length > 0) {
        this.seznamVklopljenih = pridobljenSeznamVklopljenih.filter(x => !this.seznamVklopljenih.includes(x))
        this.seznamVklopljenihStoritev = this.seznamVklopljenih.filter(x => x.idVrsta !== StoritevVrstaEnum.NAROCNISKA_VEZAVA)
        this.dolzinaSeznamaStoritev = this.seznamVklopljenihStoritev.length
        let tmpArray2 = []
        for (let i = 0; i < this.dolzinaSeznamaStoritev; i += 6) {
          tmpArray2.push(this.seznamVklopljenihStoritev.slice(i, i + 6))
        }
        this.seznamVklopljenihStoritev = tmpArray2
        this.PrikaziStranSeznamStoritev(1)
        for (let i = 0; i < this.seznamVklopljenih.length; i++) {
          let idVrstaStoritve = this.seznamVklopljenih[i].idVrsta
          if (idVrstaStoritve === parseInt(StoritevVrstaEnum.INTERNET_OPTIKA) ||
              idVrstaStoritve === parseInt(StoritevVrstaEnum.INTERNET_PRD) ||
              idVrstaStoritve === parseInt(StoritevVrstaEnum.INTERNET_SRD)) {
            this.trenutnoIzbranaHitrost = this.seznamVklopljenih[i]
          } else if (idVrstaStoritve === parseInt(StoritevVrstaEnum.TRZNI_PAKET)) {
            this.trenutniTrzniPaket = this.seznamVklopljenih[i]
            this.trenutniTrzniPaketVklopljenOd = this.seznamVklopljenih[i].trajanjeOd.slice(0, 10)
          } else if (idVrstaStoritve === parseInt(StoritevVrstaEnum.NAROCNISKA_VEZAVA)) {
            this.seznamVezav.push(this.seznamVklopljenih[i])
            this.seznamVezavVklopljenih = this.seznamVezav
            let tmpArray = []
            this.dolzinaSeznamaVezav = this.seznamVezavVklopljenih.length
            const chunk = 4
            for (let i = 0; i < this.dolzinaSeznamaVezav; i += chunk) {
              tmpArray.push(this.seznamVezavVklopljenih.slice(i, i + chunk))
            }
            this.seznamVezavVklopljenih = tmpArray
            let popustObj = this.GetPopustFromKonfPod3(this.seznamVklopljenih[i].konfPod3)
            Vue.set(this.seznamVklopljenih[i], 'popustProcenti', popustObj.vrednost)
            Vue.set(this.seznamVklopljenih[i], 'trajanjeUgodnosti', popustObj.trajanje)
            this.PrikaziStranSeznamVezav(1)
          } else if (idVrstaStoritve === parseInt(StoritevVrstaEnum.VARNOST)) {
            this.varnostniPaket = this.seznamVklopljenih[i]
          } else if (idVrstaStoritve === parseInt(StoritevVrstaEnum.TV_PAKETI)) {
            this.seznamProgramov.push(this.seznamVklopljenih[i])
          } else if (idVrstaStoritve === parseInt(StoritevVrstaEnum.PODATKOVNI_PAKETI)) {
            this.podatkovniPaketi = this.seznamVklopljenih[i]
          } else if (idVrstaStoritve === parseInt(StoritevVrstaEnum.TELEVIZIJA)) {
            if (this.seznamVklopljenih[i].idStoritev === parseInt(StoritevVrstaEnum.HD_TV_VMESNIK)) {
              this.hdVmesnikKolicina = this.seznamVklopljenih[i].kolicina
            }
            if (this.seznamVklopljenih[i].idStoritev === parseInt(StoritevVrstaEnum.SD_TV_VMESNIK)) {
              this.sdVmesnikKolicina = this.seznamVklopljenih[i].kolicina
            }
            if (this.seznamVklopljenih[i].idStoritev === parseInt(StoritevVrstaEnum.TV_KARTICE_COAX)) {
              this.coaxVmesnikKolicina = this.seznamVklopljenih[i].kolicina
            }
          }
        }
      }
    },
    GetPopustFromKonfPod3 (konfPod) {
      let popust = {'vrednost': '', 'trajanje': ''}
      konfPod.split(';').forEach(atrubutVrednost => {
        let vrednost = /popust=(\d+)[.,]?/.exec(atrubutVrednost)
        let trajanje = /mesecev=(\d+)/.exec(atrubutVrednost)
        if (vrednost) popust['vrednost'] = vrednost[1]
        if (trajanje) popust['trajanje'] = trajanje[1] + ' mesecev'
      })
      return popust
    },
    SetSeznamNarocenihStoritev (prenParametri, seznamNarocenih) {
      this.naroceneStrotive = []
      if (seznamNarocenih.length > 0) {
        this.naroceneStrotive = seznamNarocenih
      }
    },
    PrikaziStranSeznamVezav (stran) {
      if (typeof this.seznamVezavVklopljenih[stran - 1] !== 'undefined') {
        this.seznamPodVezav = this.seznamVezavVklopljenih[stran - 1]
      } else {
        this.seznamPodVezav = this.seznamVezavVklopljenih
      }
    },
    PrikaziStranSeznamStoritev (stran) {
      if (typeof this.seznamVklopljenihStoritev[stran - 1] !== 'undefined') {
        this.seznamPodStoritev = this.seznamVklopljenihStoritev[stran - 1]
      } else {
        this.seznamPodStoritev = this.seznamVklopljenihStoritev
      }
    },
    GetSmartTvInfo () {
      if (this.izbranPrikljucek !== '' && this.izbranPrikljucek !== null) {
        let param = ['subscriberId=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(
          this,
          'fora/devices/info?',
          param,
          null,
          'SetSmartTvInfo',
          'ErrSmartTvInfo')
      }
    },
    SetSmartTvInfo (podatki) {
      if (podatki.data.length > 0) {
        this.seznamSmartTv = podatki.data.length
      } else {
        this.seznamSmartTv = 0
      }
    },
    ErrSmartTvInfo (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PridobitevStaticnegaApija () {
      if (this.izbranPrikljucek !== '' && typeof this.izbranPrikljucek !== 'undefined' &&
        this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/internet/ip',
          param,
          null,
          'SetPridobitevStaticnegaApija',
          'ErrPridobitevStaticnegaApija')
      }
    },
    SetPridobitevStaticnegaApija (podatki) {
      this.trenutnaPostavitevInternetVec = []
      this.trenutnaPostavitevInternetEna = []
      if (typeof podatki.data !== 'undefined' && podatki.data.length > 0) {
        if (podatki.data.length === 1) {
          this.prikazpodatkovInternet = 0
          this.trenutnaPostavitevInternetEna = podatki.data
        } else {
          this.prikazpodatkovInternet = 1
          this.trenutnaPostavitevInternetVec = podatki.data
        }
      }
    },
    ErrPridobitevStaticnegaApija (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PridobitevTrenutniPrenos () {
      if (this.izbranPrikljucek !== '' && typeof this.izbranPrikljucek !== 'undefined' &&
        this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/internet/postavitev',
          param,
          null,
          'SetPridobitevTrenutniPrenos',
          'ErrPridobitevTrenutniPrenos')
      }
    },
    SetPridobitevTrenutniPrenos (podatki) {
      this.trenutniPrenosDownload = 0
      this.trenutniPrenosUpload = 0
      if (podatki.data !== null &&
            podatki.data !== [] &&
            typeof podatki.data.download !== 'undefined' &&
            typeof podatki.data.upload !== 'undefined' &&
            podatki.data.download !== null &&
            podatki.data.upload !== null) {
        let trenutniPrenosDownload = this.PretvoriMeritveHitrosti(podatki.data.download)
        this.trenutniPrenosDownload = (trenutniPrenosDownload.vrednost).toFixed(2) + ' ' +
            trenutniPrenosDownload.enota
        let trenutniPrenosUpload = this.PretvoriMeritveHitrosti(podatki.data.upload)
        this.trenutniPrenosUpload = (trenutniPrenosUpload.vrednost).toFixed(2) + ' ' +
            trenutniPrenosUpload.enota
      }
    },
    ErrPridobitevTrenutniPrenos (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PridobitevTrenutniNarocnik () {
      if (this.izbranPrikljucek !== '') {
        let param = ['permissions[]=PORABA_TELEFONIJA']
        param.push('permissions[]=TR_OPREMA')
        param.push('permissions[]=ADMIN_PORABA_TELEFONIJA')
        this.clientAgent.postWsRequest(
          this,
          'permissions/all',
          param,
          null,
          'SetPridobitevTrenutniNarocnik',
          'ErrPridobitevTrenutniNarocnik')
      }
    },
    SetPridobitevTrenutniNarocnik (podatki) {
      this.seznamFiksnihStevilk = []
      if (typeof podatki.results.PORABA_TELEFONIJA.additionalData !== 'undefined' &&
        podatki.results.PORABA_TELEFONIJA.additionalData.length > 0) {
        for (let i = 0; i < podatki.results.PORABA_TELEFONIJA.additionalData.length; i++) {
          if (podatki.results.PORABA_TELEFONIJA.additionalData[i].id_prikljucek === this.izbranPrikljucek) {
            if (podatki.results.PORABA_TELEFONIJA.additionalData[i].objava === 0) {
              Vue.set(podatki.results.PORABA_TELEFONIJA.additionalData[i], 'ObjavlenoVimeniku', 'Da')
            } else {
              Vue.set(podatki.results.PORABA_TELEFONIJA.additionalData[i], 'ObjavlenoVimeniku', 'Ne')
            }
            if (podatki.results.PORABA_TELEFONIJA.additionalData[i].tip_stevilke === '1') {
              this.seznamFiksnihStevilk.push(podatki.results.PORABA_TELEFONIJA.additionalData[i])
              let tmpArray = []
              this.dolzinaSeznamaFiks = this.seznamFiksnihStevilk.length
              const chunk = 4
              for (let i = 0; i < this.dolzinaSeznamaFiks; i += chunk) {
                tmpArray.push(this.seznamFiksnihStevilk.slice(i, i + chunk))
              }
              this.PrikaziStranFiksnaTelefonija(1)
            } else if (podatki.results.PORABA_TELEFONIJA.additionalData[i].tip_stevilke === '5') {
              this.seznamMobilnihStevilk.push(podatki.results.PORABA_TELEFONIJA.additionalData[i])
            }
          }
        }
        if (typeof podatki.results.PORABA_TELEFONIJA.additionalData !== 'undefined' &&
          podatki.results.PORABA_TELEFONIJA.additionalData.length > 0) {
          this.seznamTelefonskih = podatki.results.PORABA_TELEFONIJA.additionalData
        }
        let tmpArray = []
        this.dolzinaSeznama = this.seznamTelefonskih.length
        const chunk = 5
        if (this.dolzinaSeznama !== null) {
          for (let i = 0; i < this.dolzinaSeznama; i += chunk) {
            tmpArray.push(this.seznamTelefonskih.slice(i, i + chunk))
          }
          this.seznamTelefonskih = tmpArray
          this.PrikaziStran(1)
        }
      }
      if (typeof podatki.results.ADMIN_PORABA_TELEFONIJA.additionalData !== 'undefined' &&
        podatki.results.ADMIN_PORABA_TELEFONIJA.additionalData !== null &&
        podatki.results.ADMIN_PORABA_TELEFONIJA.additionalData.length > 0) {
        this.seznamTelefonskih = podatki.results.ADMIN_PORABA_TELEFONIJA.additionalData
        let tmpArray = []
        this.dolzinaSeznama = this.seznamTelefonskih.length
        const chunk = 5
        if (this.dolzinaSeznama !== null) {
          for (let i = 0; i < this.dolzinaSeznama; i += chunk) {
            tmpArray.push(this.seznamTelefonskih.slice(i, i + chunk))
          }
          this.seznamTelefonskih = tmpArray
          this.PrikaziStran(1)
        }
      }
      this.seznamTrOprema = ''
      if (podatki.results.TR_OPREMA.additionalData.length > 0 && podatki.results.TR_OPREMA.additionalData !==
          'undefined' && podatki.results.TR_OPREMA.additionalData !== null) {
        for (let i = 0; i < podatki.results.TR_OPREMA.additionalData.length; i++) {
          if (podatki.results.TR_OPREMA.additionalData[i].id_prikljucek === this.izbranPrikljucek) {
            this.seznamTrOprema = podatki.results.TR_OPREMA.additionalData[i].id_oprema_prikljucek
          }
        }
        this.PridobitevWifiPodatkov()
      }
    },
    PrikaziStran (stran) {
      if (typeof this.seznamTelefonskih[stran - 1] !== 'undefined') {
        this.seznamPodRacunov = this.seznamTelefonskih[stran - 1]
      } else {
        this.seznamPodRacunov = this.seznamTelefonskih
      }
    },
    PrikaziStranFiksnaTelefonija (stran) {
      this.trenutnoIzbranaStraFiks = stran
      this.seznamPodFiksnihStevilk = []
      this.seznamPodFiksnihStevilk = this.seznamFiksnihStevilk
    },
    PridobitevWifiPodatkov () {
      if (this.izbranPrikljucek !== '' && this.seznamTrOprema !== '') {
        let param = ['idOprema=' + this.seznamTrOprema]
        this.clientAgent.postWsRequest(
          this,
          'tr069/wifi/info?',
          param,
          null,
          'SetPodatkiWifi',
          'ErrPodatkiWifi')
      }
    },
    SetPodatkiWifi (podatki) {
      this.podatkiWifi = null
      this.podatkiWifi = podatki.data
    },
    ErrPodatkiWifi (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PridobitevNarocenihPostnihPredalov () {
      if (this.izbranPrikljucek !== '' && typeof this.izbranPrikljucek !== 'undefined' &&
        this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek, 'usageData=' + false]
        this.naroceniPostniPredali = null
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/email/seznam',
          param,
          null,
          'SetPridobitevNarocenihPostnihPredalov',
          'ErrPridobitevNarocenihPostnihPredalov')
      }
    },
    SetPridobitevNarocenihPostnihPredalov (podatki) {
      this.naroceniPostniPredali = podatki
    },
    ErrPridobitevNarocenihPostnihPredalov (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PridobimoTvShemo () {
      if (this.izbranPrikljucek !== '' && typeof this.izbranPrikljucek !== 'undefined' &&
        this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.seznamTvShem = null
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/infoTvShema?',
          param,
          null,
          'SetTvShema',
          'ErrTvShema')
      }
    },
    SetTvShema (podatki) {
      this.seznamTvShem = podatki.seznamStoritev
    },
    ErrTvShema (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetSeznamOpreme () {
      if (this.izbranPrikljucek !== '' && typeof this.izbranPrikljucek !== 'undefined' &&
        this.izbranPrikljucek !== null) {
        this.pridobivanjeSeznamaOpreme = true
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/zapisnikOpreme',
          param,
          null,
          'SetSeznamOpreme',
          'ErrSeznamOpreme')
      }
    },
    SetSeznamOpreme (podatki) {
      if (podatki.data !== '' || podatki.data !== null || typeof podatki.data !== 'undefined') {
        this.pridobljeniPodatki = []
        this.seznamOpreme = []
        if (typeof podatki.data.oprema !== 'undefined') {
          this.pridobljeniPodatki = podatki.data.oprema
        }
        if (this.pridobljeniPodatki.length > 0) {
          for (let i = 0; i < this.pridobljeniPodatki.length; i++) {
            this.seznamOpreme.push(this.pridobljeniPodatki[i])
          }
        }
      }
      let tmpArray = []
      this.dolzinaSeznamaMrezneOpreme = this.pridobljeniPodatki.length
      const chunk = 4
      for (let i = 0; i < this.dolzinaSeznamaMrezneOpreme; i += chunk) {
        tmpArray.push(this.pridobljeniPodatki.slice(i, i + chunk))
      }
      this.pridobljeniPodatki = tmpArray
      this.PrikaziStranSeznamOpreme(1)
    },
    PrikaziStranSeznamOpreme (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.pridobljeniPodatki[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamPodMrezneOpreme = this.pridobljeniPodatki[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamPodMrezneOpreme = this.pridobljeniPodatki
      }
      this.pridobivanjeSeznamaOpreme = false
    },
    ErrSeznamOpreme (podatki) {
      this.ShowWarningMessage(podatki)
      this.pridobivanjeSeznamaOpreme = false
    },
    GetPrikljuckiTrzniPaketi () {
      let param = ['permissionId=PRIKLJUCKI_S_TP']
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission',
        param,
        null,
        'SetPrikljuckiTrzniPaketi',
        'ErrPrikljuckiDovoljenja')
    },
    SetPrikljuckiTrzniPaketi (podatki) {
      this.prikljuckiTrzniPaketi = podatki.permission.results
    },
    GetPrikljuckiUTMS () {
      if (this.izbranPrikljucek !== '') {
        let param = ['permissionId=PRIKLJUCKI']
        param.push('filter[tip_prikljucka]=UMTS')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPodUmtsStevilk = []
      this.seznamUmtsStevilk = []
      this.seznamUmts = []
      this.seznamUmts = podatki.permission.additionalData
      for (let i = 0; i < this.seznamUmts.length; i++) {
        if (this.seznamUmts[i].id_prikljucek === this.izbranPrikljucek) {
          if (this.seznamUmts[i].objava === '1') {
            Vue.set(this.seznamUmts[i], 'ObjavlenoVimeniku', 'Da')
          } else {
            Vue.set(this.seznamUmts[i], 'ObjavlenoVimeniku', 'Ne')
          }
          this.seznamUmtsStevilk.push(this.seznamUmts[i])
        }
      }
      let tmpArray = []
      this.dolzinaSeznamaUmts = this.seznamUmtsStevilk.length
      const chunk = 4
      for (let i = 0; i < this.dolzinaSeznamaUmts; i += chunk) {
        tmpArray.push(this.seznamUmtsStevilk.slice(i, i + chunk))
      }
      this.seznamUmtsStevilk = tmpArray
      this.PrikaziStranMobilnaTelefonija(1)

      this.prenosniParametriZaStoritveUMTS = {
        'vmesnik': this,
        'prenesenIzbranId': this.izbranPrikljucek,
        'idVrsta': [].concat(this.seznamIskanihStoritevUMTS),
        'idStatusNaroceno': 0,
        'idStatusVklopljeno': 1
      }
      this.GetVklopljeneStoritve(this.prenosniParametriZaStoritveUMTS)
    },
    PrikaziStranMobilnaTelefonija (stran) {
      this.trenutnoIzbranaStraUmts = stran
      if (typeof this.seznamUmtsStevilk[this.trenutnoIzbranaStraUmts - 1] !== 'undefined') {
        this.seznamPodUmtsStevilk = this.seznamUmtsStevilk[this.trenutnoIzbranaStraUmts - 1]
      } else {
        this.seznamPodUmtsStevilk = this.seznamUmtsStevilk
      }
    },
    ErrPrikljuckiDovoljenja (podatki) {
      this.ShowWarningMessage(podatki)
    }
  },
  computed: {
    hasPrikljuckeTrzniPaketi () {
      if (this.izbranPrikljucek !== null) {
        return this.prikljuckiTrzniPaketi.includes(Number(this.izbranPrikljucek))
      }
      return false
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/PregledStoritev/NaroceneStoritve.css?">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/NaroceneStoritve.vue